import { BusinessUnitAddressService } from './business-unit-address.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BUSINESS_UNIT_ADDRESS_TYPE, BusinessUnitAddress } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class BusinessUnitAddressResolverBase implements Resolve<BusinessUnitAddress> {

  constructor(protected service: BusinessUnitAddressService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BusinessUnitAddress> {
    const key: number = BUSINESS_UNIT_ADDRESS_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



